import React, { useContext, useReducer, useState } from "react"
import { FC } from "react"
import { DocumentType } from "../../../@types/enumsGlobal"
import useGridFilter, { GridFilterAction } from "../../hooks/useGridFilter"
import { defaultGridContextState, gridContextReducerHandler } from "./GridContext"
import { defaultTreeViewContextState, treeViewContextReducerHandler } from "./TreeViewContext"
import { useTabsContext } from "../tabsProvider"

interface ITreeViewContext {
    visiblePanel: boolean
    isModal: boolean
    selectedFolder?: ITreeViewFolder
    onVisiblePanelEvent: (visible: boolean) => void
    onModalEvent: (value: boolean) => void
    onSelectEvent: (value: ITreeViewFolder) => void
    onUnselectEvent: () => void
}
interface IGridContext {
    selectedItem?: ISelectGridRow | undefined
    selectedDetailItem?: ISelectGridRow | undefined
    document?: DocumentType
    view?: boolean
    idTab?: string
    onSelectEvent: (value: ISelectGridRow, document: DocumentType) => void
    onSelectDetailEvent: (value: ISelectGridRow) => void
    onUnselectEvent: () => void
    onUnselectDetailEvent: () => void
    refreshState: (value: boolean) => void
}
interface ILotContext {
    gridFilter: IGridFilter
    dispatchGridFilter: (action: GridFilterAction) => void
    setSelectedItem: (value: IGridRow | undefined) => void
    selectedItem?: IGridRow | undefined
}
interface IPluginContext {
    masterGrid: IGridContext
    treeView: ITreeViewContext
    lots: ILotContext
    // detailsGrids?: IGridContext[]
}
const defaultPluginContext: IPluginContext = {
    masterGrid: {
        onSelectEvent: (value, document) => { },
        onSelectDetailEvent: (value) => { },
        onUnselectEvent: () => { },
        onUnselectDetailEvent: () => { },
        refreshState: (value) => {}
    },
    treeView: {
        visiblePanel: false,
        isModal: false,
        onVisiblePanelEvent: (visible) => { },
        onModalEvent: (value) => { },
        onSelectEvent: (value) => { },
        onUnselectEvent: () => { }
    },
    lots: {
        gridFilter: {
            numberPerPage: 10,
            pageNumber: 1,
            columnFilters: []
        },
        dispatchGridFilter: (value: GridFilterAction) => { },
        setSelectedItem: (value: ISelectGridRow | undefined) => { }
    }
}

export const PluginContext = React.createContext<IPluginContext>(defaultPluginContext)
export const usePluginContext = () => useContext(PluginContext)

interface IPluginProviderProps {
    plugin?: IPluginSettings
}
export const PluginProvider: FC<IPluginProviderProps> = (props) => {
    const [masterGridState, dispatchMasterGrid] = useReducer(gridContextReducerHandler, defaultGridContextState)
    const [treeViewState, dispatchTreeView] = useReducer(treeViewContextReducerHandler, defaultTreeViewContextState)

    //lot
    const [selectedLot, setSelectedLot] = useState<IGridRow | undefined>()
    const [gridFilter, dispatchGridFilter] = useGridFilter()

    const tabsCtx = useTabsContext();
    
    return <>
        <PluginContext.Provider value={{
            masterGrid: {
                selectedItem: masterGridState.selectedItem,
                selectedDetailItem: masterGridState.selectedItemDetail,
                document: masterGridState.document,
                view: masterGridState.view,
                idTab: masterGridState.idTab,
                onSelectEvent: (value, document) => dispatchMasterGrid({ type: "select", payload: { 
                    item: value, 
                    document: document, 
                    idTab: tabsCtx.currentTab ? tabsCtx.currentTab.id : ""} 
                }),
                onSelectDetailEvent: (value) => dispatchMasterGrid({ type: "selectDetail", payload: { item: value } }),
                onUnselectEvent: () => dispatchMasterGrid({ type: "unselect", payload: { idTab: tabsCtx.currentTab ? tabsCtx.currentTab.id : ""} }),
                onUnselectDetailEvent: () => dispatchMasterGrid({ type: "unselectDetail" }),
                refreshState: (value) => dispatchMasterGrid({ type: 'refresh', payload: value }),
            } as IGridContext,
            treeView: {
                visiblePanel: treeViewState.visiblePanel,
                isModal: treeViewState.isModal,   
                onVisiblePanelEvent: (visible) => dispatchTreeView({ type: 'visible', payload: visible }),
                onModalEvent: (value) =>  dispatchTreeView({ type: 'modal', payload: value }),
                selectedFolder: treeViewState.selectedFolder,
                onSelectEvent: (value) => dispatchTreeView({ type: 'select', payload: value }),
                onUnselectEvent: () => dispatchTreeView({ type: "unselect" })
            } as ITreeViewContext,
            lots: {
                selectedItem: selectedLot,
                gridFilter: gridFilter,
                dispatchGridFilter: (action: GridFilterAction) => dispatchGridFilter(action),
                setSelectedItem: (value: IGridRow | undefined) => setSelectedLot(value),

            } as ILotContext
        }}>
            {props.children}
        </PluginContext.Provider>
    </>
}